import React from "react";

export default function Message() {
  return (
    <div className="max-w-5xl mx-auto py-16 px-8 ">
      <h2 className="text-2xl font-bold clear-left pb-6">
        Message from Mr. Arastoo Khan, Member Secretary of the National Advisory
        Board (NAB) for Impact Investment in Bangladesh
      </h2>
      <p>Dear Impact Investment Stakeholders,</p>
      <p className="">Greetings from NAB Bangladesh!</p>

      <div className="py-4">
        As our nation enters a new chapter of governance following the
        successful democratic transition and the formation of the newly elected
        Government, we at the National Advisory Board (NAB) for Impact
        Investment view this moment as a renewed opportunity to strengthen
        Bangladesh's economic foundations and accelerate inclusive growth. We
        believe that the current Government's mandate for reform and its focus
        on economic resilience provide a unique window to unlock the full
        potential of impact investments.
      </div>
      <div>
        NAB will recalibrate its strategic focus to complement the Government's
        economic reform agenda, especially in building a robust and credible
        impact investment ecosystem that mobilizes domestic and international
        capital for long-term development outcomes. We remain committed to
        working closely with policymakers, investors, development partners, and
        ecosystem actors to translate these priorities into scalable impact
        solutions.
      </div>
      <div className="py-4">
        Together, we believe there is a unique opportunity to advance
        responsible investment practices that support economic resilience,
        social inclusion, and shared prosperity for the people of Bangladesh.
      </div>
      <p>Thank you for your continued engagement and partnership.</p>
      <p className="py-4">Yours Sincerely,</p>
      <div className="">
        <p className="font-bold">Arastoo Khan</p>
        <p className="font-bold">Chair, NAB Trust</p>
        <p>Member Secretary, NABG</p>
      </div>
    </div>
  );
}
